import SurveyDomainService from "../Survey/Survey.service";
export default class SurveyResponseDomainService {
    static fromJSON(json) {
        // @ts-expect-error - TS2740 - Type '{ survey: Survey; createdDate: Date; lastSync: any; statusDate: any; }' is missing the following properties from type 'SurveyResponse': id, recipient, sender, regarding, and 3 more.
        return Object.assign(Object.assign({}, json), { survey: SurveyDomainService.fromJSON(json.survey), createdDate: new Date(json.createdDate), lastSync: json.lastSync && new Date(json.lastSync), statusDate: json.statusDate && new Date(json.statusDate) });
    }
}
